import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Button         from '@material-ui/core/Button';
import Dialog         from '@material-ui/core/Dialog';
import Paper          from '@material-ui/core/Paper';
import TextField      from '@material-ui/core/TextField';
import Typography     from '@material-ui/core/Typography';

import { post } from './util';

const useStyles = makeStyles((theme) => ({
  paper: {
    alignItems: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    margin: '0',
    padding: '50px 100px 50px 100px',
  },
}));

function LogIn(props) {
  const classes = useStyles();

  const [ username, setUsername ] = React.useState('');
  const [ password, setPassword ] = React.useState('');

  const { token, setToken } = props.context.getStates();

  const logIn = () => {
    const body  = new FormData();
    body.append('username', username);
    body.append('password', password);

    post.forToken(body).then(response => {
      setToken({
        access: response.access_token,
        refresh: response.refresh_token,
      });
    });
  }

  return (
    <Dialog fullWidth open={token.access === ''}>
      <Paper className={classes.paper}>
        <Typography align="center" variant="h1">
          Ticket TA
        </Typography>
        <TextField className={classes.textField}
          label="Username"
          onChange={(event) => { setUsername(event.target.value); }}
          value={username}
          variant="outlined"
        />
        <TextField className={classes.textField}
          label="Password"
          onChange={(event) => { setPassword(event.target.value); }}
          type="password"
          // autoComplete="current-password"
          value={password}
          variant="outlined"
        />
        <Button variant="contained" color="primary"
          onClick={(event) => { logIn(); }}
        >{'로그인'}</Button>
      </Paper>
    </Dialog>
  );
}

export default LogIn;
